import type { FC } from 'react';
import React from 'react';
import { IconArrowRight } from '@alfa-bank/site-icon/arrow-right';

import { NavButton } from './nav-button';
import type { IArrow } from './models';

export const ArrowRight: FC<IArrow> = props => {
    return (
        <NavButton {...props}>
            <IconArrowRight height={14} width={20} />
        </NavButton>
    );
};
